import CaptableOperationsComparator from './container';

export default CaptableOperationsComparator;
